// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#stories_wrapper[data-v-012ca816]{width:100%;height:100%;overflow:hidden}#stories_wrapper #stories_slider[data-v-012ca816]{height:100%;position:relative}#stories_wrapper #stories_slider.withTransition[data-v-012ca816]{transition:margin .3s ease-out}", ""]);
// Exports
module.exports = exports;
